
import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image'
import Modal from 'react-bootstrap/Modal';
import ErrorWindow from '../../components/ErrorWindow/ErrorWindow.js';
import InfoWindow from '../../components/InfoWindow/InfoWindow.js';
import './Ustawienia.css';
import axios from 'axios';
import MenuTop from '../../components/MenuTop/MenuTop.js';
import {
    useParams
} from "react-router-dom";
const DAO_SKLEP_URL = process.env.REACT_APP_PS_AMARKA_SITE + '/api/' + process.env.REACT_APP_PS_AMARKA_API_VER + '/producent';
export default function Ustawienia() {
    const [unazwa, setUnazwa] = useState();
    const [uadres, setUadres] = useState();
    const [ukod_pocztowy, setUkod_pocztowy] = useState();
    const [umiejscowosc, setUmiejscowosc] = useState();
    const [uwww, setUwww] = useState();
    const [producent, setProducent] = useState({ nip: "tt" });
    let { nip } = useParams();

    let biRefInfoWindow = {
    };
    let biRefErrorWindow = {
    };
    function getErrowWindow() {
        return biRefErrorWindow;
    }
    let refDodajOkno = {
        getErrowWindow: getErrowWindow
    };

    console.log("ustawienia nip useParams:" + nip);
    //czyli tutaj zaczytujemy dane nipu jeżeli ma do nich user uprawnienia
    //i ustawiamy do tokena
    //na przyszłośc zrobić tak aby odświeżało. 
    const fetchProducent = async () => {
        console.log("produkt.nazwa: " + producent.nip);

        const res = await axios(DAO_SKLEP_URL, {
            method: 'POST',
            withCredentials: false,
            headers: {
                'Accept': 'application/json'
            },
            data: { operacja: "producent", nip: nip }
        }).then((response) => {
            console.log("resp.daa:" + JSON.stringify(response.data));
            if (typeof (response.data.error) != 'undefined') {
                console.log("show error" + JSON.stringify(response.data.error));
                biRefErrorWindow.pokazOkno(response.data.error.info);
                sessionStorage.removeItem('token');
                window.setTimeout(() => {
                    window.location = process.env.PUBLIC_URL+"/start";
                }, 2000);
                return null;
            }
            sessionStorage.setItem('producent', JSON.stringify(response.data.producent));
            return response.data.producent;
        }).catch(err => console.log(err.message));
        if (res === null) {
            return;
        }
        setProducent(res);
        setUdane(res);
    };
    function setUdane(res) {
        setUnazwa(res.nazwa);
        setUadres(res.adres);
        setUkod_pocztowy(res.kod_pocztowy);
        setUmiejscowosc(res.miejscowosc);
        setUwww(res.www);
    }
    function DodajNowy() {
        console.log("dodaj nowy");
        refDodajOkno.PokazOkno();
    }
    useEffect(() => {
        fetchProducent();
    }, producent);

    return (<Container fluid className="p-0" >
        <Row className="menu-top shadow-sm">
            <Col className="mt-2 mb-2">
                <MenuTop />
            </Col>
        </Row>
        <Container className="justify-content-md-center">
            <Col>
                <Form className="ustawienia-formularz mt-2" onSubmit={handleSubmitUstawienia}>
                    <Form.Group as={Row} controlId="unazwa">
                        <Form.Label column sm="2">Nazwa</Form.Label>
                        <Col sm="10">
                            <Form.Control className="formularz-control mt-1" size="sm" name="unazwa" type="text" onChange={e => setUnazwa(e.target.value)} value={unazwa} placeholder="Wprowadź nazwę producenta..." />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formPlaintextPassword">
                        <Form.Label column sm="2">NIP</Form.Label>
                        <Col sm="10">
                            <Form.Control className="formularz-control mt-1" size="sm" name="unip" type="text" readonly value={producent.nip} placeholder="Wprowadź NIP..." />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="uadres">
                        <Form.Label column sm="2">Adres</Form.Label>
                        <Col sm="10">
                            <Form.Control className="formularz-control mt-1" size="sm" name="uadres" as="textarea" onChange={e => setUadres(e.target.value)} value={uadres} rows={3} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="ukod_pocztowy">
                        <Form.Label column sm="2">Kod pocztowy</Form.Label>
                        <Col sm="10">
                            <Form.Control className="formularz-control mt-1" size="sm" type="text" name="ukod_pocztowy" onChange={e => setUkod_pocztowy(e.target.value)} value={ukod_pocztowy} placeholder="Wprowadź kod pocztowy..." />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="umiejscowosc">
                        <Form.Label column sm="2">Miejscowość</Form.Label>
                        <Col sm="10">
                            <Form.Control className="formularz-control mt-1" size="sm" type="text" name="umiejscowosc" onChange={e => setUmiejscowosc(e.target.value)} value={umiejscowosc} placeholder="Wprowadź miejscowść..." />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="uwww">
                        <Form.Label column sm="2">Strona www</Form.Label>
                        <Col sm="10">
                            <Form.Control className="formularz-control mt-1" size="sm" type="text" name="uwww" onChange={e => setUwww(e.target.value)} value={uwww} placeholder="Wprowadź stronę www..." />
                        </Col>
                    </Form.Group>
                    <Button variant="primary" type="submit" className="zapisz float-right">
                        <Image className="logo-zapisz" src="https://pics.freeicons.io/uploads/icons/png/18769148821543238916-512.png" />
                        Zapisz
                                   </Button>
                    <Button variant="primary" className="zapisz float-right mr-2" onClick={DodajNowy}>
                        <Image className="logo-zapisz" src="https://pics.freeicons.io/uploads/icons/png/18769148821543238916-512.png" />
                        Dodaj nowy
                                   </Button>
                    <DodajNowyDialog biRef={refDodajOkno} />
                    <ErrorWindow biRef={biRefErrorWindow} />
                    <InfoWindow biRef={biRefInfoWindow} />
                </Form>
            </Col>
        </Container>
    </Container>);
    function handleSubmitUstawienia(event) {
        event.preventDefault();
        const data = new FormData(event.target);
        console.log(data.get('unazwa')); // reference by form input's `name` tag
        producent.nazwa = data.get('unazwa');
        producent.adres = data.get('uadres');
        producent.kod_pocztowy = data.get('ukod_pocztowy');
        producent.miejscowosc = data.get('umiejscowosc');
        producent.www = data.get('uwww');
        console.log("handleSubmitUstawienia producent.nazwa:" + producent.nazwa);
        console.log("handleSubmitUstawienia producent.nazwa:" + JSON.stringify({ operacja: "zapisz", producent: producent }));
        const zapiszClose = async () => {
            const res = await axios(DAO_SKLEP_URL, {
                method: 'POST',
                withCredentials: false,
                headers: {
                    'Accept': 'application/json'
                },
                data: { operacja: "zapisz", producent: producent }
            }).then((response) => {

                if (typeof (response.data.error) != 'undefined') {
                    console.log("show error" + JSON.stringify(response.data.error));
                    biRefErrorWindow.pokazOkno(response.data.error.info);
                    return null;
                }
                console.log("resp.daa:" + JSON.stringify(response.data));
                sessionStorage.setItem('producent', JSON.stringify(response.data.producent));

                return response.data.producent;
            }).catch(err => console.log(err.message));
            console.log("xxxx" + JSON.stringify(res));
            if (!res) {
                return;
            }
            biRefInfoWindow.pokazOkno("Dane zapisano");
            window.setTimeout(() => {
                window.location = process.env.PUBLIC_URL+"/ustawienia/" + producent.nip;
            }, 2000);
        }
        zapiszClose();
    }
}
function DodajNowyDialog(props) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [nip, setNip] = useState("");
    const [nazwa, setNazwa] = useState("");
    function PokazOkno() {
        // The parent component can call this function.
        // The parent component can call this function.
        console.log("someChildFunction");
        setShow(true);
    }
    const dodajClose = async () => {

        const res = await axios(DAO_SKLEP_URL, {
            method: 'POST',
            withCredentials: false,
            headers: {
                'Accept': 'application/json'
            },
            data: { operacja: "dodaj", nip: nip, nazwa: nazwa }
        }).then((response) => {

            if (typeof (response.data.error) != 'undefined') {
                console.log("show error" + JSON.stringify(response.data.error));
                props.biRef.getErrowWindow().pokazOkno(response.data.error.info);
                return null;
            }
            console.log("resp.daa:" + JSON.stringify(response.data));
            sessionStorage.setItem('producent', JSON.stringify(response.data.producent));
            return response.data.producent;
        }).catch(err => console.log(err.message));
        console.log("xxxx" + JSON.stringify(res));
        if (!res) {
            return;
        }
        window.location = process.env.PUBLIC_URL+"/ustawienia/" + res.nip;

    };
    props.biRef.PokazOkno = PokazOkno;
    return (
        <>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                className="obramowanie-producent"
            >
                <Modal.Header className="tytul-producent" closeButton>
                    <Modal.Title>Dodaj producenta</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form className="producent-formularz">
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>NIP</Form.Label>
                            <Form.Control className="producent" type="text" onChange={e => setNip(e.target.value)} placeholder="NIP" />
                        </Form.Group>
                        <Form.Group controlId="formBasicPassword">
                            <Form.Label>Nazwa</Form.Label>
                            <Form.Control className="producent" type="text" onChange={e => setNazwa(e.target.value)} placeholder="Podaj nazwę" />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={dodajClose}>
                        Dodaj
            </Button>
                    <Button variant="danger" onClick={handleClose}>
                        Zamknij
            </Button>

                </Modal.Footer>
            </Modal>
        </>
    );
}
